import { ApiClientInstance } from '@shared/api';

import {
  InsuranceAssetType,
  InsuranceIndexFilterEnum,
  TLivePrice,
  TPerformance,
  TPriceTrend,
  TUserAsset,
} from './types';

export const getUserAsset = (assetType: InsuranceAssetType) => {
  return ApiClientInstance.get<TUserAsset>(`v2/investment/Insurance/${assetType}/user-asset`);
};

export const getLivePrice = (assetType: InsuranceAssetType) => {
  return ApiClientInstance.get<TLivePrice>(`v2/investment/Insurance/${assetType}/live`);
};

export const getPerformance = (assetType: InsuranceAssetType) => {
  return ApiClientInstance.get<TPerformance>(`v2/investment/insurance/${assetType}/performance`);
};

export const getPriceTrend = (assetType: InsuranceAssetType, filter?: InsuranceIndexFilterEnum) => {
  return ApiClientInstance.get<TPriceTrend>(`v2/investment/insurance/${assetType}/index`, {
    ...(filter && { queryParams: { filter } }),
  });
};
